(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appeals-page"]) return;
  try {
    

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var faqBtns = document.querySelectorAll('.faq-q');
    for (var i = 0; i < faqBtns.length; i++) {
      (function(btn) {
        btn.addEventListener('click', function() {
          var item = btn.parentNode;
          var isOpen = item.className.indexOf('open') !== -1;
          var allItems = document.querySelectorAll('.faq-item');
          for (var j = 0; j < allItems.length; j++) {
            allItems[j].className = allItems[j].className.replace(' open','');
          }
          if (!isOpen) { item.className += ' open'; }
        });
      })(faqBtns[i]);
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divorce-page"]) return;
  try {
    

(function() {
  var currentPath = 'free';

  window.mecSelectPath = function(path) {
    currentPath = path;
    var cardFree   = document.getElementById('card-free');
    var cardReport = document.getElementById('card-report');
    var ttl        = document.getElementById('mec-form-ttl');
    var btn        = document.getElementById('mec-submit-btn');
    if (path === 'report') {
      cardFree.className   = cardFree.className.replace(' selected','');
      cardReport.className = cardReport.className.indexOf('selected') === -1
        ? cardReport.className + ' selected' : cardReport.className;
      ttl.textContent = 'Portability Valuation Report - $1,250';
      btn.textContent = 'Order Report \u2192';
    } else {
      cardReport.className = cardReport.className.replace(' selected','');
      cardFree.className   = cardFree.className.indexOf('selected') === -1
        ? cardFree.className + ' selected' : cardFree.className;
      ttl.textContent = 'Free Portability Check';
      btn.textContent = 'Submit Free Portability Check \u2192';
    }
  };

  window.mecBeforeSubmit = function(e) {
    var required = ['mec-first','mec-last','mec-emailf','mec-role','mec-address','mec-county'];
    var valid = true;
    for (var i = 0; i < required.length; i++) {
      var el = document.getElementById(required[i]);
      if (!el || !el.value.trim()) {
        if (el) { el.style.borderColor = '#e05555'; }
        valid = false;
      } else {
        el.style.borderColor = '';
      }
    }
    if (!valid) {
      e.preventDefault();
      alert('Please fill in all required fields.');
      return false;
    }

    var first  = document.getElementById('mec-first').value.trim();
    var last   = document.getElementById('mec-last').value.trim();
    var email  = document.getElementById('mec-emailf').value.trim();
    var phone  = document.getElementById('mec-phone').value.trim() || 'Not provided';
    var role   = document.getElementById('mec-role').value;
    var addr   = document.getElementById('mec-address').value.trim();
    var county = document.getElementById('mec-county').value;
    var notes  = document.getElementById('mec-notes').value.trim() || 'None';
    var type   = currentPath === 'report' ? 'FULL REPORT - INVOICE REQUESTED ($1,250)' : 'FREE INITIAL CHECK';

    document.getElementById('mec-name').value  = first + ' ' + last;
    document.getElementById('mec-email').value = email;
    document.getElementById('mec-body').value  =
      'TYPE: ' + type + '\n\n' +
      'NAME: ' + first + ' ' + last + '\n' +
      'EMAIL: ' + email + '\n' +
      'PHONE: ' + phone + '\n' +
      'ROLE: ' + role + '\n\n' +
      'PROPERTY ADDRESS: ' + addr + '\n' +
      'COUNTY: ' + county + '\n\n' +
      'NOTES: ' + notes;

    // Prevent default, show confirmation, then actually submit via XHR
    e.preventDefault();

    var formEl = document.getElementById('mec-intake-form');
    var formData = new FormData(formEl);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/contact', true);
    xhr.onload = function() {
      document.getElementById('mec-form-wrap').style.display = 'none';
      if (currentPath === 'report') {
        document.getElementById('mec-success-report').style.display = 'block';
      } else {
        document.getElementById('mec-success-free').style.display = 'block';
      }
      var intakeSec = document.getElementById('intake');
      if (intakeSec) {
        intakeSec.scrollIntoView({behavior: 'smooth'});
      }
    };
    xhr.onerror = function() {
      // Fallback: submit normally so email still goes through
      formEl.submit();
    };
    xhr.send(formData);
    return false;
  };

  // FAQ accordion
  document.addEventListener('DOMContentLoaded', function() {
    var faqBtns = document.querySelectorAll('.faq-q');
    for (var i = 0; i < faqBtns.length; i++) {
      (function(btn) {
        btn.addEventListener('click', function() {
          var item = btn.parentNode;
          var isOpen = item.className.indexOf('open') !== -1;
          var allItems = document.querySelectorAll('.faq-item');
          for (var j = 0; j < allItems.length; j++) {
            allItems[j].className = allItems[j].className.replace(' open','');
          }
          if (!isOpen) { item.className += ' open'; }
        });
      })(faqBtns[i]);
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage"]) return;
  try {
    

(function() {
  var canvas = document.getElementById('moneyCanvas');
  if (!canvas) { return; }
  var ctx = canvas.getContext('2d');
  var bills = [];

  function resizeCanvas() {
    var hero = document.querySelector('.hero');
    if (!hero) { return; }
    canvas.width = window.innerWidth;
    canvas.height = hero.offsetHeight;
  }

  function makeBill() {
    return {
      x: Math.random() * canvas.width,
      y: -60,
      w: 54 + Math.random() * 34,
      h: 25 + Math.random() * 14,
      speed: 0.55 + Math.random() * 1.2,
      angle: (Math.random() - 0.5) * 0.45,
      rot: (Math.random() - 0.5) * 0.016,
      drift: (Math.random() - 0.5) * 0.38,
      opacity: 0.28 + Math.random() * 0.44
    };
  }

  function drawBill(b) {
    ctx.save();
    ctx.translate(b.x + b.w / 2, b.y + b.h / 2);
    ctx.rotate(b.angle);
    ctx.globalAlpha = b.opacity;
    ctx.fillStyle = 'rgba(0,200,224,.06)';
    ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
    ctx.strokeStyle = '#00c8e0';
    ctx.lineWidth = 0.9;
    ctx.strokeRect(-b.w / 2, -b.h / 2, b.w, b.h);
    ctx.strokeRect(-b.w / 2 + 3, -b.h / 2 + 3, b.w - 6, b.h - 6);
    ctx.fillStyle = 'rgba(0,200,224,.58)';
    ctx.font = 'bold ' + Math.floor(b.h * 0.52) + 'px monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('$', 0, 0);
    ctx.restore();
  }

  function animateBills() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (bills.length < 55) { bills.push(makeBill()); }
    bills = bills.filter(function(b) { return b.y < canvas.height + 70; });
    for (var i = 0; i < bills.length; i++) {
      bills[i].y += bills[i].speed;
      bills[i].x += bills[i].drift;
      bills[i].angle += bills[i].rot;
      drawBill(bills[i]);
    }
    requestAnimationFrame(animateBills);
  }

  resizeCanvas();
  for (var i = 0; i < 50; i++) {
    var b = makeBill();
    b.y = Math.random() * canvas.height;
    bills.push(b);
  }
  animateBills();
  window.addEventListener('resize', resizeCanvas);
})();


  } catch(e) { console.error(e); }
})();
})();
